import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  private translocoService = inject(TranslocoService);

  constructor() {
    super();
    
    // Subscribe to language changes
    this.translocoService.langChanges$.subscribe(() => {
      this.updateTranslations();
    });
    
    // Initialize translations
    this.updateTranslations();
  }

  private updateTranslations(): void {
    this.itemsPerPageLabel = this.translocoService.translate('Items per page');
    this.nextPageLabel = this.translocoService.translate('Next page');
    this.previousPageLabel = this.translocoService.translate('Previous page');
    this.firstPageLabel = this.translocoService.translate('First page');
    this.lastPageLabel = this.translocoService.translate('Last page');
    
    // Trigger change detection
    this.changes.next();
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.translocoService.translate('0 of {{length}}', { length });
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length 
      ? Math.min(startIndex + pageSize, length) 
      : startIndex + pageSize;
    return this.translocoService.translate('{{startIndex}} - {{endIndex}} of {{length}}', {
      startIndex: startIndex + 1,
      endIndex,
      length
    });
  };
}
